import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { SAL2070_R01Dto } from './Dto_SAL2070_R01';
import { defaultSAL2070_R01Dto } from './Dto_SAL2070_R01';
import { formatDate } from 'src/utils/string/stringUtil';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';

export interface SAL2070_R01Filter {
	
	taxBilling: string;
	compCd: string;
	customCd: string;
	dateRange: DateRange | undefined;
	tradeType: string;
}
export interface Store_SAL2070_R01 {
	SAL2070_R01Filter: SAL2070_R01Filter;
	SAL2070_R01PastFilter: SAL2070_R01Filter;
	setSAL2070_R01Filter: (filter: Partial<Store_SAL2070_R01['SAL2070_R01Filter']>) => void;
	setSAL2070_R01PastFilter: (filter: Store_SAL2070_R01['SAL2070_R01PastFilter']) => void;
	
	// ====== 세금계산서 정보 리스트 및 선택/편집 ======
	SAL2070_R01List: SAL2070_R01Dto[];
	setSAL2070_R01List: (list: SAL2070_R01Dto[]) => void;

	editSAL2070_R01: SAL2070_R01Dto | null;
	setEditSAL2070_R01: (editSale: SAL2070_R01Dto | null) => void;

	selectedSAL2070_R01: SAL2070_R01Dto | undefined;
	setSelectedSAL2070_R01: (data: SAL2070_R01Dto | undefined) => void;
	initSelectedSAL2070_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedSAL2070_R01DetailList: string[];
	setDeletedSAL2070_R01DetailList: (idList: string[]) => void;
	addDeletedSAL2070_R01DetailList: (idList: string[]) => void;
	removeDeletedSAL2070_R01DetailList: (idList?: string[]) => void;

	// ====== 세금계산서 정보 상세(디테일) 데이터 ======
	SAL2070_R01DetailList: SAL2070_R01Dto[];
	setSAL2070_R01DetailList: (data: SAL2070_R01Dto[]) => void;
	insertSAL2070_R01DetailList: (data: SAL2070_R01Dto[], index?: number) => void;
	removeSAL2070_R01DetailList: (index: number) => void;
	updateSAL2070_R01DetailList: (index: number, data: SAL2070_R01Dto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedSAL2070_R01DetailList: string[];
	setSelectedSAL2070_R01DetailList: (idList: string[]) => void;
	addSelectedSAL2070_R01DetailList: (idList: string[]) => void;
	removeSelectedSAL2070_R01DetailList: (idList?: string[]) => void;
	initSelectedSAL2070_R01DetailList: () => void;

	originalSAL2070_R01DetailList: SAL2070_R01Dto[];
	setOriginalSAL2070_R01DetailList: (data: SAL2070_R01Dto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	

	// ====== 초기화 ======
	initData: () => void;

}

export const defaultSAL2070_R01Filter : SAL2070_R01Filter = {
	
	taxBilling: '',
	compCd: '',
	customCd: '',
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	tradeType: ''
};

export const useSAL2070_R01Store = create<Store_SAL2070_R01>((set) => ({
	SAL2070_R01Filter: defaultSAL2070_R01Filter,
	SAL2070_R01PastFilter: defaultSAL2070_R01Filter,
	setSAL2070_R01Filter: (update) => set((state) => ({
		SAL2070_R01Filter: {
			...state.SAL2070_R01Filter,
			...update
		}
	})),
	setSAL2070_R01PastFilter: (filter: Store_SAL2070_R01['SAL2070_R01PastFilter']) => set((state) => {
		return {
			...state,
			SAL2070_R01PastFilter: filter
		}
	}),

	// ====== 세금계산서 정보 리스트 및 선택/편집 ======
	SAL2070_R01List: [],
	setSAL2070_R01List: (list: SAL2070_R01Dto[]) => set((state) => {

		let valueIndex = 1;
		list.forEach(item => {
			item.valueIndex = valueIndex;
			valueIndex++;
		});

		return {
			...state,
			SAL2070_R01List: list
		}
	}),

	editSAL2070_R01: defaultSAL2070_R01Dto,
	setEditSAL2070_R01: (editSale: SAL2070_R01Dto | null) => set((state) => {
		return {
			...state,
			editSAL2070_R01: editSale
		}
	}),

	selectedSAL2070_R01: undefined,
	// 세금계산서 정보 행 선택 시 edit도 동기화
	setSelectedSAL2070_R01: (data: SAL2070_R01Dto | undefined) => set((state) => {
		let editData: SAL2070_R01Dto | null;
		if (data) {
			const defaultCompCd = useCommonCodeStore.getState().compCdList[0]?.compCd ?? '';
			editData = {
				...data,
				issuedDt: data.issuedDt || formatDate(new Date()),
				// 미발행(list) 행은 API가 compCd를 null로 줄 수 있어 기본 사업장으로 보정
				...(data.taxBilling !== 'Y'
					? { compCd: defaultCompCd }
					: {}),
			};
		} else {
			editData = defaultSAL2070_R01Dto;
		}
		return { selectedSAL2070_R01: data, editSAL2070_R01: editData, detailScrollTop: null };
	}),
	initSelectedSAL2070_R01: () => set({ selectedSAL2070_R01: undefined, editSAL2070_R01: defaultSAL2070_R01Dto, SAL2070_R01DetailList: [] }),

	// ====== 세금계산서 정보 상세(디테일) 데이터 ======
	SAL2070_R01DetailList: [],
	setSAL2070_R01DetailList: (data: SAL2070_R01Dto[]) => set((state) => {
		let newList: SAL2070_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultSAL2070_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			SAL2070_R01DetailList: newList
		}
	}),
	insertSAL2070_R01DetailList: (data: SAL2070_R01Dto[], index?: number) => set((state) => {
		let newSAL2070_R01DetailList = [...state.SAL2070_R01DetailList];

		let targetRowData = newSAL2070_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newSAL2070_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newSAL2070_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newSAL2070_R01DetailList = newSAL2070_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newSAL2070_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultSAL2070_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newSAL2070_R01DetailList.splice(index, 0, ...newData);
		} else {
			newSAL2070_R01DetailList.push(...newData);
		}

		return {
			...state,
			SAL2070_R01DetailList: newSAL2070_R01DetailList
		}
	}),
	removeSAL2070_R01DetailList: (index: number) => set((state) => {
		const newSAL2070_R01DetailList = [...state.SAL2070_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			SAL2070_R01DetailList: newSAL2070_R01DetailList
		}
	}),
	updateSAL2070_R01DetailList: (valueIndex: number, data: SAL2070_R01Dto) => set((state) => {
		const _SAL2070_R01DetailList = state.SAL2070_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			SAL2070_R01DetailList: _SAL2070_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedSAL2070_R01DetailList: [],
	setDeletedSAL2070_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedSAL2070_R01DetailList: idList
		}
	}),
	addDeletedSAL2070_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedSAL2070_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.SAL2070_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.SAL2070_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedSAL2070_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedSAL2070_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedSAL2070_R01DetailList: [...state.deletedSAL2070_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedSAL2070_R01DetailList: [],
	setSelectedSAL2070_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedSAL2070_R01DetailList: idList
		}
	}),
	addSelectedSAL2070_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedSAL2070_R01DetailList = [...state.selectedSAL2070_R01DetailList];
		if(idList.length > 0) {
			_selectedSAL2070_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedSAL2070_R01DetailList: _selectedSAL2070_R01DetailList
		}
	}),
	removeSelectedSAL2070_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedSAL2070_R01DetailList: [...state.selectedSAL2070_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedSAL2070_R01DetailList: () => set({ selectedSAL2070_R01DetailList: [] }),

	originalSAL2070_R01DetailList: [],
	setOriginalSAL2070_R01DetailList: (data: SAL2070_R01Dto[]) => set((state) => {
		let newList: SAL2070_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultSAL2070_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalSAL2070_R01DetailList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
						

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		SAL2070_R01Filter: defaultSAL2070_R01Filter,
		SAL2070_R01PastFilter: defaultSAL2070_R01Filter,
		SAL2070_R01List: [],
		selectedSAL2070_R01: undefined,
		SAL2070_R01DetailList: [],
		deletedSAL2070_R01DetailList: [],
		selectedSAL2070_R01DetailList: [],
		editSAL2070_R01: defaultSAL2070_R01Dto,
		allCount: 0,
		columnState: null,
		detailColumnState: null,
		scrollTop: null,
		detailScrollTop: null,
	})),

	
}));
